import request from "@/utils/request";

// 请柬详情
export async function detail(params) {
  params.is_edit = 1;
  const url = params.is_tpl
    ? `/api/app-invitation/v1/template/${params.id}/preview`
    : `/api/app-invitation/v1/invitation/${params.id}`;
  return request(
    {
      url,
      params
    },
    {
      shouldLoading: false
    }
  );
}
